import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ProfileComponent } from "./profile.component";
import { CreatedDiscussionsComponent } from "./created-discussions/created-discussions.component";
import { VotedDiscussionsComponent } from "./voted-discussions/voted-discussions.component";
import { BookmarkedDiscussionsComponent } from "./bookmarked-discussions/bookmarked-discussions.component";
import { ProfileResolver } from "../../../shared/services";

const routes: Routes = [
  {
    path: "", // path is "profile/:username"
    component: ProfileComponent,
    data: {
      title: "User Profile",
      icon: "ti-user",
      caption: "View profiles here",
      status: true,
    },
    resolve: {
      profile: ProfileResolver,
    },
    children: [
      {
        path: "",
        component: CreatedDiscussionsComponent,
      },
      {
        path: "voted",
        component: VotedDiscussionsComponent,
      },
      {
        path: "bookmarked",
        component: BookmarkedDiscussionsComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProfileRoutingModule {}
